import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Tooltip } from "antd";
import {
  LabelDataHeading,
  ValueDataHeading,
  UnderlyingContent,
  ContentDivider,
  CustomizedIcon,
} from "../../../style";
import { ModelDataHeading } from "../style";
import { isGeminiUser } from "../../../../../../../utils/sessionUtil";
import { addressFormat } from "../../../utils";
import { removeNtee } from "../../../../../../../CommonComponents/CharitySearch/utils";
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";

export default function SavedCharityCard({
  data,
  pendingCharityHandler,
  removeSavedCharity,
  activityBlocked = "",
}) {
  return (
    <div>
      <Row>
        <Col span={2}>
          <CustomizedIcon
            data-test="saved-charity-section"
            type="star"
            theme="filled"
            onClick={(e) => removeSavedCharity(e, data)}
          />
        </Col>
        <Col span={22}>
          <ModelDataHeading>{data.charityName}</ModelDataHeading>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={12}>
          <LabelDataHeading>EIN</LabelDataHeading>
          <ValueDataHeading>{data.ein}</ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHeading>Address</LabelDataHeading>
          <Tooltip
            placement="bottom"
            title={addressFormat({ ...data, zipCode: data.zip })}
            trigger="click"
          >
            <UnderlyingContent>{data.location}</UnderlyingContent>
          </Tooltip>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={12}>
          <LabelDataHeading>Interest Area</LabelDataHeading>
          <ValueDataHeading>
            {data.interestArea ? removeNtee(data.interestArea) : ""}
          </ValueDataHeading>
        </Col>
      </Row>
      <ContentDivider />
      {isGeminiUser() && (
        <>
          <Row className="geminiColor">
            <Col span={12}>
              <LabelDataHeading>Grantee Org. Status</LabelDataHeading>
              <ValueDataHeading>{data.granteeOrgStatus}</ValueDataHeading>
            </Col>
          </Row>
          <ContentDivider />
        </>
      )}
      <Row>
        <Col span={8}>
          <CapsuleButton
            data-test="saved-charity-capsule"
            onClick={() => pendingCharityHandler(data)}
            disabled={!!activityBlocked}
            title={activityBlocked}
            text="Select"
            whiteBackground
            iconType="arrowRight"
            alt = "select charity"
          />
        </Col>
      </Row>
    </div>
  );
}

SavedCharityCard.propTypes = {
  activityBlocked: PropTypes.bool,
  data: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string,
    charityId: PropTypes.number,
    charityName: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    cypherText: PropTypes.any,
    ein: PropTypes.string,
    einCi: PropTypes.any,
    granteeOrgAliasId: PropTypes.number,
    granteeOrgs: PropTypes.any,
    interestArea: PropTypes.string,
    isExisting: PropTypes.bool,
    isPending: PropTypes.bool,
    location: PropTypes.string,
    purpose: PropTypes.any,
    savedCharitieList: PropTypes.any,
    state: PropTypes.string,
    success: PropTypes.any,
    zip: PropTypes.string,
  }),
  index: PropTypes.number,
  pendingCharityHandler: PropTypes.func,
  removeSavedCharity: PropTypes.bool,
};
